import { gql } from "apollo-boost";

const SHOW_RECAPTCHA = gql`
  query showRecaptcha {
    show_recaptcha
  }
`;

export default SHOW_RECAPTCHA;
